// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"945":"dashboard","966":"login"}[chunkId] || chunkId) + "." + {"48":"0899e063","167":"9668e7cb","247":"8bdc99a5","299":"616301c4","726":"500ed771","750":"bf3c418c","945":"6380a7bd","966":"e993b1be"}[chunkId] + ".css";
};